import { render, staticRenderFns } from "./SupplyValidator.vue?vue&type=template&id=4d68a6d7&scoped=true"
import script from "./SupplyValidator.vue?vue&type=script&lang=js"
export * from "./SupplyValidator.vue?vue&type=script&lang=js"
import style0 from "./SupplyValidator.vue?vue&type=style&index=0&id=4d68a6d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d68a6d7",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Supplies/Validation/SupplyValidator.vue
// module id = 2166
// module chunks = 31